import { useUserAuthentication } from '»utils/customHooks';

import { AppBarPrivate } from './Private';
import { AppBarPublic } from './Public/AppBarPublic';

export const AppBar = () => {
  const { isUserAuthenticated } = useUserAuthentication();

  if (isUserAuthenticated) return <AppBarPrivate />;

  return <AppBarPublic />;
};
